import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Button, Field, H1, Input, Select } from '@itds/elements/index.js';

import Config from '@/config';

import Api from '@carrier/utils/Api';

const Preview = () => {
  const { state } = useLocation();
  const { eticket } = state; // grab eticket passed through state in react router by clicking on eticket in EmbeddableEtickets.js table
  const params = useParams();

  const [data, setData] = useState({
    eticket_id: '',
    etickets: [],
    loaded_eticket_id: '',
    loaded_quote_id: '',
    quote_id: ''
  });

  useEffect(() => {
    Api.loadEtickets(params.id).then(({ data }) => {
      setData({ etickets: data });
    });
  }, []);

  const handleChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const loadPreview = () => {
    setData({ ...data, loaded_quote_id: data.quote_id, loaded_eticket_id: data.eticket_id });
  };

  useEffect(() => {
    window.LIFEDX_ETICKET = {
      token: params.id
    };

    if (data.quote_id) {
      window.LIFEDX_ETICKET.quote_id = data.quote_id;
    }

    if (data.eticket_id) {
      window.LIFEDX_ETICKET.eticket_id = data.eticket_id;
    }

    const script = document.createElement('script');

    script.src = `${Config.LIFEDX_EMBED_URL}/eticket/js/eticket.widget.js`;
    script.type = 'application/javascript';
    script.id = 'lifedx_eticket_form';

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [data.loaded_eticket_id, data.loaded_quote_id]);

  return (
    <>
      <H1>{eticket && eticket.name}</H1>

      <div style={{ display: 'flex', width: '100%' }}>
        <div style={{ display: 'flex', width: '60%' }}>
          <Field label='Quote ID' style={{ flex: 1, marginRight: '5px' }}>
            <Input onChange={handleChange.bind(null, 'quote_id')} value={data.quote_id} />
          </Field>
          <Field label='Recent Unfinished E-Tickets' style={{ flex: 2, marginRight: '5px' }}>
            <Select
              onChange={handleChange.bind(null, 'eticket_id')}
              options={[{ value: '', label: '-- No E-Ticket --' }].concat(
                data.etickets.map(eticket => {
                  return {
                    value: eticket.id
                  };
                })
              )}
              value={data.eticket_id}
            />
          </Field>
        </div>
        <div style={{ padding: '30px 0 0 10px' }}>
          <Button color={'PRIMARY'} onClick={loadPreview.bind(null)} small={true}>
            Load Into Preview
          </Button>
        </div>
      </div>

      <div id='lifedx_eticket_form' />
    </>
  );
};

export default Preview;
